/**
 * Batch options guaranteed to contain the applied batch. The options load asynchronously (and a
 * failed load leaves them empty), but the applied batch can come from the navigation state or the
 * `?batch=` param before that: without an option the filter chip and its slideout control would be
 * missing while the list stays narrowed.
 *
 * @param {{ value: string, label: string }[]} batches
 * @param {string} importBatch The applied batch id ('' for none).
 * @param {string} fallbackLabel Label shown until the real one is known.
 */
export const withAppliedBatch = (batches, importBatch, fallbackLabel) =>
  !importBatch || batches.some((batch) => batch.value === importBatch)
    ? batches
    : [...batches, { value: importBatch, label: fallbackLabel }];
